import React, { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';

function isTokenExpired(token: string): boolean {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]!));
        return typeof payload.exp === 'number' && payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}

const PublicOnlyRoute: FC<React.PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');

    if (token) {
        if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return <>{children}</>;
        }
        return (
            <Navigate
                to={{
                    pathname: '/home',
                }}
                state={{ from: location }}
                replace
            />
        );
    }

    return <>{children}</>;
};

export default PublicOnlyRoute;
